import { PureComponent, ReactNode } from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

import { PrintConfig } from '../../../../api/pushVisit';
import { Actions } from '../../../../store/actions';
import { GlobalState } from '../../../../store/reducers';
import {
    getPrescription,
    isCreateDialogVisible,
    getPrintConfigs,
} from '../../../../store/selectors/prescriptionPad';
import { getIsMilestoneEnabled, getPxElementConfig } from '../../../../store/selectors/session';
import { GeniePadElementsSettingItem } from '../../../../api/pushGenie';
import { Prescription } from '../../../../store/types/prescription';
import MagicBox from '../../../../pages/prescriptionPad/magicBox/MagicBox';
import { isGridPadV3Container, isMagicContainerOpen } from './NavBar';
import MainPanelComponents from './MainPanelComponents';
import { MAGIC_BOX_CONTAINER, MAIN_CONTAINER_ID } from './containers';
import { PP_SUB_ROUTES } from '../../../../routes/paths';
import { upsertGenieSetting } from '../../../../store/actions/session';

interface Props {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    isTemplateDialogVisisble: boolean;
    padElementsConfig?: GeniePadElementsSettingItem[];
    pres?: Prescription;
    printConfigs?: PrintConfig;
    subRoute?: PP_SUB_ROUTES | undefined;
    isMilestoneEnabled?: boolean;
}

const MAGIC_BOX_DISABLED_ROUTES: Set<PP_SUB_ROUTES | ''> = new Set([
    'vaccination',
    'milestones',
    'care-canvas',
    'related-profiles',
    'medical-records',
]);

class MainPanelV2 extends PureComponent<Props> {
    componentDidMount(): void {
        const { padElementsConfig, isMilestoneEnabled } = this.props;

        if (isMilestoneEnabled) {
            const isMilestonePresent = padElementsConfig?.find((c) => c.id === 'milestones');
            const restElements = padElementsConfig?.filter((t) => t.id !== 'milestones') ?? [];

            if (!isMilestonePresent) {
                const newPadElementConfig = [
                    {
                        id: 'milestones',
                        name: 'Growth Milestones',
                        isShown: true,
                        isAutoCopy: false,
                    },
                    ...restElements,
                ];

                this.props.dispatch(
                    upsertGenieSetting({
                        padElements: newPadElementConfig,
                    }),
                );
            }
        }
    }

    render(): ReactNode {
        const { subRoute = '' } = this.props;

        return (
            <div
                className={`${isGridPadV3Container} ${
                    MAGIC_BOX_DISABLED_ROUTES.has(subRoute) ? '' : 'grid'
                } h-full w-full min-w-840 flex-1 overflow-x-auto overflow-y-hidden relative mt-2 h-full`}
                id={MAIN_CONTAINER_ID}
            >
                <MainPanelComponents />
                {!MAGIC_BOX_DISABLED_ROUTES.has(subRoute) && (
                    <div
                        className={`mb-72 py-16 pr-16 flex relative ${isMagicContainerOpen}`}
                        style={{
                            minHeight: 'calc(100% - 70px)',
                            height: 'calc(100% - 70px)',
                            maxHeight: 'calc(100% - 70px)',
                        }}
                        id={MAGIC_BOX_CONTAINER}
                    >
                        <MagicBox />
                    </div>
                )}
            </div>
        );
    }
}

export default connect((state: GlobalState) => ({
    isTemplateDialogVisisble: isCreateDialogVisible(state),
    padElementsConfig: getPxElementConfig(state),
    pres: getPrescription(state),
    printConfigs: getPrintConfigs(state),
    isMilestoneEnabled: getIsMilestoneEnabled(state),
}))(MainPanelV2);
